export const CustomToggle = ({
  checked,
  onChange,
  label,
}: {
  checked: boolean;
  onChange: (next: boolean) => void;
  label?: string;
}) => (
  <label
    style={{
      display: "inline-flex",
      alignItems: "center",
      gap: 8,
      cursor: "pointer",
      fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Text', 'SF Pro Display', system-ui, sans-serif",
      fontSize: 13,
      color: "var(--dk-text, #1d1d1f)",
      userSelect: "none",
    }}
  >
    {label && <span>{label}</span>}
    <span
      onClick={() => onChange(!checked)}
      style={{
        position: "relative",
        width: 40,
        height: 24,
        borderRadius: 12,
        background: checked ? "#2563eb" : "#e5e5ea",
        transition: "background 0.18s ease",
        flexShrink: 0,
      }}
    >
      <span
        style={{
          position: "absolute",
          top: 2,
          left: checked ? 18 : 2,
          width: 20,
          height: 20,
          borderRadius: "50%",
          background: "var(--dk-surface, #fff)",
          boxShadow: "0 1px 3px rgba(0,0,0,0.3)",
          transition: "left 0.18s ease",
        }}
      />
    </span>
  </label>
);
